import React from "react";
import { Col, Form, ListGroupItem, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

/**
 * 
 * used in: NotificationList - NotificationPage
 * 
 * @param {notification} props notification object
 * @param {addToSelected} props function to add to selected list
 * @param {removeFromSelected} props function to remove from selected list
 */
const NotificationListItem = (props) => {

    const navigate = useNavigate();
    const regex = /(<([^>]+)>)/gi;
    const notification = props.notification;
    const message = props.notification.notification.message.replace(regex, " ");

    const clickHandler = () => {
        navigate(`details/${notification.id}/`);
    }

    const checkHandler = (e) => {
        if (e.checked) {
            props.addToSelected(notification.id);
        }
        else {
            props.removeFromSelected(notification.id);
        }
    }

    return (
        <ListGroupItem action>
            <Row className="align-items-center">
                <Col xs="1" md="1" xl="1" className="text-center">
                    <Form.Check
                        type="checkbox"
                        id={`check-${notification.id}`}
                        onChange={e => checkHandler(e.target)}
                    />
                </Col>
                <Col xs="11" md="9" xl="9" onClick={() => clickHandler()}>
                    <b className={!notification.is_read? "text-energo": "text-muted"}>
                        {!notification.is_read?
                            <div className="bg-energo pulse" style={{height:"10px", width: "10px", borderRadius: "25px", display: "inline-block", marginRight: "8px", marginBottom: "1px"}}></div>
                        :null}
                        {notification.notification.title}
                    </b>
                    <div className="text-truncate text-muted">
                        <small>{message}</small>
                    </div>
                </Col>
                <Col xs="12" md="2" xl="2" className="text-end">
                    <p className={!notification.is_read? "text-energo":"text-muted"}>{new Date(notification.notification.created).toLocaleDateString('DE-de')}</p>
                </Col>
            </Row>
        </ListGroupItem>
    )
}

export default NotificationListItem;